var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VideoSwiper',{attrs:{"video-list":_vm.videoList,"biz-data":{ pageSource: 'pc-video-detail', page_code: 'PC_PHOTO_DETAIL_PAGE' }},on:{"return":_vm.handleReturn,"refresh":_vm.getData,"slideChange":_vm.replaceTitle}})
}
var staticRenderFns = []

export { render, staticRenderFns }